import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';

import {
  StyledTabs,
  StyledTab,
  StyledCount,
} from './styles';

const Tabs = ({
  className,
  tabsConfig,
  selectedTab,
  onSelectTab,
}) => {
  const parsedTabs = useMemo(() => {
    const a11yProps = (index) => ({
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    });

    return Object.keys(tabsConfig)
      .map((tab, index) => {
        const {
          label = '',
          icon: TabIcon,
          count,
          disabled = false,
          tooltip = '',
        } = tabsConfig[tab];

        const formattedCount = (count && count > 9) ? '9+' : count;

        const labelContent = (
          <>
            {label}
            {formattedCount && (
              <StyledCount>{formattedCount}</StyledCount>
            )}
          </>
        );

        return (
          <StyledTab
            label={tooltip ? (
              <Tooltip title={tooltip}>
                <span style={{ pointerEvents: 'auto' }}>{labelContent}</span>
              </Tooltip>
            ) : labelContent}
            key={tab}
            icon={TabIcon && <TabIcon />}
            value={tab}
            disabled={disabled}
            {...a11yProps(index)}
          />
        );
      });
  }, [tabsConfig]);

  return (
    <StyledTabs
      value={selectedTab}
      onChange={(_, value) => onSelectTab(value)}
      className={className}
      variant="fullWidth"
    >
      {parsedTabs}
    </StyledTabs>
  );
};

Tabs.propTypes = {
  className: PropTypes.string,
  tabsConfig: PropTypes.object.isRequired,
  selectedTab: PropTypes.string,
  onSelectTab: PropTypes.func,
};

Tabs.defaultProps = {
  className: '',
  selectedTab: 0,
  onSelectTab: () => {},
};

export default Tabs;
